module.exports = __webpack_public_path__ + "static/media/don-miguel RUIZ.5387aede.jpg";